import React from 'react';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import { Box, Center, Flex, Button, Stack } from '@chakra-ui/react';
import { findT } from '@interness/web-core/src/components/_helpers';
import routes from '@interness/web-core/config/routes';
import Logo from '@interness/web-core/src/components/media/Logo/Logo';
import SEO from '@interness/web-core/src/components/modules/SEO/SEO';
import BrandsSubnavigation from '@interness/brands-addon/src/components/modules/BrandsSubnavigation/BrandsSubnavigation';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import Heading from '@interness/web-core/src/components/text/Heading/Heading';
import * as S from './styles';
import CallToAction from '../../../../components/CallToAction/CallToAction';
import { jsx as ___EmotionJSX } from "@emotion/react";
const BrandsPageTemplate = props => {
  const {
    type,
    lang
  } = props.pageContext;
  const brands = props.data.allDirectusBrands.nodes;
  const brandInfo = findT(props.data.directusBrandTypes.translations, lang);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SEO, {
    title: brandInfo.display_name
  }), ___EmotionJSX(BrandsSubnavigation, {
    type: type
  }), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX(Wrapper, {
    width: 1024
  }, ___EmotionJSX(Heading, {
    subtitle: `bei ${findT(props.data.directusProject.translations, lang).seo_title}`
  }, "Markenwelt ", brandInfo.display_name), ___EmotionJSX(S.TypeDescription, {
    dangerouslySetInnerHTML: {
      __html: brandInfo.description
    }
  }), ___EmotionJSX(Spacer, {
    height: 20
  })), ___EmotionJSX(Spacer, {
    height: 40
  }), ___EmotionJSX(Wrapper, {
    width: 1024
  }, ___EmotionJSX(Spacer, {
    height: 120
  }), brands.map((_ref, i) => {
    let {
      brand
    } = _ref;
    const isEven = i % 2 === 0;
    if (!brand.gallery_images_square[0]) {
      console.log(`Quadratic imagages missing for ${brand.display_name}`);
      return;
    }
    return ___EmotionJSX(Flex, {
      key: brand.display_name,
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: isEven ? 'row-reverse' : 'row',
      mb: '140px',
      bg: "base.200",
      rounded: '2xl',
      position: "relative",
      maxHeight: "300px"
    }, ___EmotionJSX(Box, {
      w: ['100%', '100%', '60%'],
      p: '12'
    }, ___EmotionJSX(Center, null, ___EmotionJSX(Stack, null, ___EmotionJSX(Box, {
      maxHeight: '80px'
    }, ___EmotionJSX(Logo, {
      logo: brand.logo.localFile,
      title: brand.display_name,
      svgFill: '#000',
      svgWidth: "240px",
      svgHeight: "80px",
      imageWidth: "240px"
    })), ___EmotionJSX(Button, {
      variant: 'ghost',
      colorScheme: "brand",
      style: {
        textDecoration: 'none'
      },
      as: Link,
      to: `${routes[brand.type.type][lang]}/${brand.slug}`
    }, "Mehr erfahren")))), ___EmotionJSX(Box, {
      w: ['100%', '100%', '40%']
    }, ___EmotionJSX(Box, {
      rounded: '2xl',
      boxShadow: '2xl',
      overflow: 'hidden',
      ml: ['auto', 'auto', '50px'],
      mr: ['auto', 'auto', '50px'],
      mt: ['-30px', '-30px', '-130px'],
      maxW: ['200px', '200px', '100%'],
      textAlign: "center"
    }, ___EmotionJSX(Img, {
      fluid: brand.gallery_images_square[0].file.localFile.childImageSharp.fluid,
      alt: brand.display_name
    }))));
  })), ___EmotionJSX(CallToAction, null));
};
const query = "2846313299";
export default BrandsPageTemplate;